import React from "react";
import {withRouter} from "react-router";
import classNames from "classnames";

import ClipLoader from 'react-spinners/ClipLoader';
import Typography from '@material-ui/core/Typography';

import API from "@beardeddevops/react.api";
import Framework from "@beardeddevops/react.framework";
import Types from 'constants/Types';
import {Button} from "reactstrap";
import InputAdornment from "@material-ui/core/InputAdornment";

class Account extends Framework.Components.Object {

	constructor(props) {
		/**
		 *  @typedef {Accounts_Subscriptions_Object} this.state    Skus
		 */
		super(props, Types.Accounts._name);
		this.noDelete = false;
		this.state.warningShown = false;
		this.state.emailWarningShown = false;
		this.state.showPassword = false;
		this.state.showNewPassword = false;
		this.state.showPasswordRetype = false;
	}

	async handleSubmit(event) {
		if (typeof event !== 'undefined') event.preventDefault();
		this.setState({loading: true});
		if (this.handleProcess()) {
			this.model.submit(this, API.RequestType.UPDATE, false).then((data) => {
				window.location.reload();
			});
		} else {
			this.setState({loading: false});
			this.props.attemptedSave(false);
		}
		return false;
	}

	redirect = "/settings";
	// noinspection JSUnusedGlobalSymbols
	account_level = true;

	loadSelfActual(data) {
		super.loadSelfActual(data);
		this.setState({password: ''});
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);
		const watchedKeys = ['showNewPassword', 'showPasswordRetype', 'showPassword'];
		if (watchedKeys.some(key => prevState[key] !== this.state[key])) {
			this.setState({ key: Math.random() });
		}
	}

	form = () => {
		let {properties} = this.model;
		let {
			name_first,
			name_first_error,
			name_last,
			name_last_error,
			email,
			email_error,
			password_temp,
			password_temp_error,
			password_re,
			password_re_error,
			password,
			password_error,
			password_new,
			password_new_error,
			reference_id,
			reference_id_error
		} = this.state;

		const isTacticalPay = window.isTacticalPay;
		const isCashPlan = this.props.rootState.location_plan === 2;

		return (
			<div>
				<div>
					{(name_first || name_last) && <div>
						<Typography variant="h5" component="h2">
							{name_first} {name_last}
						</Typography>
						<hr/>
					</div>}
					<div className={'row'}>

						<div className={'col-4'}>
							<div className="form-group">
								<Framework.Elements.TextField name={"name_first"}
								                              label={"First Name"}
								                              property={properties.name_first}
								                              value={name_first}
								                              error={name_first_error}
								                              update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
						</div>
						<div className={'col-4'}>
							<div className="form-group">
								<Framework.Elements.TextField name={"name_last"}
								                              label={"Last Name"}
								                              property={properties.name_last}
								                              value={name_last}
								                              error={name_last_error}
								                              update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
						</div>
						<div className={'col-4'}>
							<div className="form-group">
								<Framework.Elements.TextField name={"email"}
								                              label={"Email"}
								                              property={properties.email}
								                              value={email}
								                              error={email_error}
								                              update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
						</div>
						<div className={'col-4'}>
							<div className="form-group">
								<Framework.Elements.TextField key={this.state.key}
															  name={"password_new"}
								                              label={"New Password"}
								                              property={properties.password_new}
								                              value={password_new}
								                              error={password_new_error}
								                              update={this.handleTextFieldPropertyUpdate}
								                              type={this.state.showNewPassword ? "text" : "password"}
								                              InputProps={{
									                              endAdornment: (
										                              <i
											                              className={`fa ${this.state.showNewPassword ? "fa-eye-slash" : "fa-eye"}`}
											                              onClick={() => this.setState({ showNewPassword: !this.state.showNewPassword })}
											                              style={{ cursor: "pointer" }}
										                              />
									                              ),
									                              shrink: false
								                              }}
								/>
							</div>
						</div>
						<div className={'col-4'}>
							<div className="form-group">
								<Framework.Elements.TextField key={this.state.key}
															  name={"password_re"}
								                              label={"Retype Password"}
								                              property={properties.password_re}
								                              value={password_re}
								                              error={password_re_error}
								                              update={this.handleTextFieldPropertyUpdate}
								                              type={this.state.showPasswordRetype ? "text" : "password"}
								                              InputProps={{
									                              endAdornment: (
										                              <i
											                              className={`fa ${this.state.showPasswordRetype ? "fa-eye-slash" : "fa-eye"}`}
											                              onClick={() => this.setState({ showPasswordRetype: !this.state.showPasswordRetype })}
											                              style={{ cursor: "pointer" }}
										                              />
									                              ),
									                              shrink: false
								                              }}
								                              onKeyPress={e => {
									                              if (e.key === 'Enter' && this.state.pkey) {
										                              this.handleSubmit()
									                              }
								                              }}
								/>
							</div>
						</div>
						<div className={'col-4'}>
							<div className="form-group">
								<Framework.Elements.TextField key={this.state.key}
															  name={"password"}
								                              label={"Current or Temporary Password"}
								                              property={properties.password}
								                              value={password}
								                              error={password_error}
								                              update={this.handleTextFieldPropertyUpdate}
								                              type={this.state.showPassword ? "text" : "password"}
								                              InputProps={{
									                              endAdornment: (
										                              <i
											                              className={`fa ${this.state.showPassword ? "fa-eye-slash" : "fa-eye"}`}
											                              onClick={() => this.setState({ showPassword: !this.state.showPassword })}
											                              style={{ cursor: "pointer" }}
										                              />
									                              ),
									                              shrink: false
								                              }}
								                              onKeyPress={e => {
									                              if (e.key === 'Enter') {
										                              this.handleSubmit()
									                              }
								                              }}
								/>
							</div>
						</div>

						{/*<div className={'col-4'} onClick={() => {*/}
						{/*	if (!this.state.warningShown) {*/}
						{/*		alert("Adding an API key will upgrade your account to the Terminal plan if you have active terminals. This will result in a price increase.")*/}
						{/*		this.state.warningShown = true;*/}
						{/*	}*/}
						{/*}}>*/}
						{/*	<Framework.Elements.TextField name={"reference_id"}*/}
						{/*	                              label={"Current API Key (last 4) - Contact Support to Remove"}*/}
						{/*	                              property={properties.reference_id}*/}
						{/*	                              value={reference_id}*/}
						{/*	                              error={reference_id_error}*/}
						{/*	                              update={this.handleTextFieldPropertyUpdate}*/}
						{/*	/>*/}
						{/*</div>*/}

					</div>
				</div>

				{!isCashPlan && (
					<>
						<hr/>

						<div>
							<Typography variant="h6" component="h3">
								Terminal Options
							</Typography>

							<div className={'row'}>
								<div className={'col-2'}>
									<div className='form-group'>
										<Framework.Elements.ButtonSwitch
											value={this.state.has_altrupay}
											error={this.state.has_altrupay_error}
											property={properties.has_altrupay}
											update={(property, value) => {
												if (value !== false) {
													this.setState({ reference_id: null });
												}
												this.handleTextFieldPropertyUpdate(property, value);
											}}
											labelTrue={isTacticalPay ? "TacticalPay" : "Altrupay"}
											labelFalse={"Fluidpay"}
											nullable={true}
											uncheck={true}
											project={'pos'}
										/>
									</div>
								</div>
								{this.state.has_altrupay === false && (
									<div className={'col-4'} onClick={() => {
										if (!this.state.warningShown) {
											alert("Adding an API key will upgrade your account to the Terminal plan if you have active terminals. This will result in a price increase.")
											this.state.warningShown = true;
										}
									}}>
										<Framework.Elements.TextField
											name={"reference_id"}
											label={"Current API Key (last 4) - Contact Support to Remove"}
											property={properties.reference_id}
											value={reference_id}
											error={reference_id_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								)}
							</div>
						</div>
					</>
				)}

				<div className={classNames("loader", {'active': properties.loading})}>
					<ClipLoader color={"#4A4A4A"} loading={properties.loading}/>
				</div>
			</div>
		)
	}
}

export default Framework.Components.withRootState(withRouter(Account));
